import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

import { BsModalModule } from 'ng2-bs3-modal';
import { Ng2SmartTableModule } from 'ng2-smart-table'


import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { ScrollToBottomDirective } from './directives/scrollable/scroll-to-bottom.directive';
import { VjsPlayerComponent } from './directives/vjs-player.component';

import { Repository } from '../services/repository'
import { TranslationService } from '../services/translation.service'
import { TranslatePipe } from './pipes/translate.pipe';
import { FillBlanksReplacePipe } from './pipes/fill-blanks-replace.pipe';
import { TranslateDirective } from './directives/translate.directive';

import { ToolDataService } from '../services/tooldata.service'
import { AuthorizationService } from '../services/authorization.service'
import { ToasterModule, ToasterService } from 'angular2-toaster';

import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { MaskedTextBoxModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';

import { DatePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { CheckBoxModule, ButtonModule, SwitchModule, RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { ScheduleAllModule, RecurrenceEditorAllModule } from '@syncfusion/ej2-angular-schedule';
import { FileManagerAllModule } from '@syncfusion/ej2-angular-filemanager';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { MultiSelectAllModule, DropDownListModule, ListBoxAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownButtonModule, SplitButtonModule, ProgressButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { TreeGridAllModule } from '@syncfusion/ej2-angular-treegrid';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { ToolbarModule, TreeViewModule, ContextMenuModule, SidebarModule } from '@syncfusion/ej2-angular-navigations';
import { SplitterModule, DashboardLayoutModule } from '@syncfusion/ej2-angular-layouts';
import { PdfViewerModule } from '@syncfusion/ej2-angular-pdfviewer';
import { AngularSplitModule } from 'angular-split';

import { NgxCurrencyModule } from "ngx-currency";
import { FileUploadModule } from 'ng2-file-upload';


import { donvisudungeditComponent } from './components/quantri/donviedit.component'
import { quatrinhdaotaoComponent } from './components/daotao/quatrinhdaotao.component'
import { thongtinkhoahoceditComponent } from './components/daotao/thongtinkhoahocedit.component'
import { lophoceditComponent } from './components/daotao/lophocedit.component'
import { dangkykhoahoceditComponent } from './components/daotao/dangkykhoahocedit.component'
import { tuvankhoahoceditComponent } from './components/daotao/tuvankhoahocedit.component'
import { dangkykheditComponent } from './components/daotao/dangkyedit.component'
import { tuvaneditComponent } from './components/daotao/tuvanedit.component'
import { danhsachlichhoceditComponent } from './components/daotao/danhsachlichhocedit.component'
import { lichhoceditComponent } from './components/daotao/lichhocedit.component'
import { danhsachgiaotrinheditComponent } from './components/daotao/danhsachgiaotrinhedit.component'
import { giaotrinheditComponent } from './components/daotao/giaotrinhedit.component'
import { nhatkychamsoceditComponent } from './components/daotao/nhatkychamsocedit.component'
import { nhatkytheodoieditComponent } from './components/dieuhanh/nhatkytheodoiedit.component'
import { hocvieneditComponent } from './components/daotao/hocvienedit.component'
import { doimatkhaueditComponent } from './components/daotao/doimatkhauedit.component'
import { doitaikhoaneditComponent } from './components/daotao/doitaikhoanedit.component'
import { baoluunghihoceditComponent } from './components/daotao/baoluunghihocedit.component'
import { khoataikhoaneditComponent } from './components/daotao/khoataikhoanedit.component'
import { chotsobuoihoceditComponent } from './components/daotao/chotsobuoihocedit.component'
import { nhacvieceditComponent } from './components/daotao/nhacviecedit.component'
import { thongbaohocphieditComponent } from './components/daotao/thongbaohocphiedit.component'
import { cauhinhhienthieditComponent } from './components/daotao/cauhinhhienthiedit.component'
import { chuyenlopeditComponent } from './components/daotao/chuyenlopedit.component'
import { chuyenlopchonhocvieneditComponent } from './components/daotao/chuyenlopchonhocvienedit.component'
import { dangkygoihoceditComponent } from './components/daotao/dangkygoihocedit.component'
import { dangkyhoceditComponent } from './components/daotao/dangkyhocedit.component'
import { dangkymuadungcueditComponent } from './components/daotao/dangkymuadungcuedit.component'
import { danhsachlophoceditComponent } from './components/daotao/danhsachlophocedit.component'
import { danhsachphatdungcueditComponent } from './components/daotao/danhsachphatdungcuedit.component'
import { datlichthuhocphieditComponent } from './components/daotao/datlichthuhocphiedit.component'
import { donghoceditComponent } from './components/daotao/donghocedit.component'
import { phanlopeditComponent } from './components/daotao/phanlopedit.component'
import { phanhocvieneditComponent } from './components/daotao/phanhocvienedit.component'
import { phanhocvientiemnangeditComponent } from './components/daotao/phanhocvientiemnangedit.component'
import { lichsuchuyenlopeditComponent } from './components/daotao/lichsuchuyenlopedit.component'
import { phatdungcueditComponent } from './components/daotao/phatdungcuedit.component'
import { phatdungcunhieueditComponent } from './components/daotao/phatdungcunhieuedit.component'
import { diemdanheditComponent } from './components/daotao/diemdanhedit.component'
import { thongkediemdanheditComponent } from './components/daotao/thongkediemdanhedit.component'

import { thietlapngaytaoeditComponent } from './components/dieuhanh/thietlapngaytaoedit.component'
import { kiemtradauvaoeditComponent } from './components/dieuhanh/kiemtradauvaoedit.component'
import { khuvuceditComponent } from './components/dieuhanh/khuvucedit.component'
import { hocvientiemnangeditComponent } from './components/dieuhanh/hocvientiemnangedit.component'
import { hocthueditComponent } from './components/dieuhanh/hocthuedit.component'
import { chitietphaithuphaitraeditComponent } from './components/dieuhanh/chitietphaithuphaitraedit.component'
import { loaiphieueditComponent } from './components/dieuhanh/loaiphieuedit.component'
import { thuchieditComponent } from './components/dieuhanh/thuchiedit.component'
import { chonhocvientiemnangeditComponent } from './components/tonghop/chonhocvientiemnangedit.component'
import { chonlophoceditComponent } from './components/tonghop/chonlophocedit.component'

import { dkycanboeditComponent } from './components/tonghop/dkycanboedit.component'
import { filemanagerComponent } from './components/quantri/filemanager.component'
import { phanheeditComponent } from './components/quantri/phanheedit.component'
import { importeditComponent } from './components/tonghop/importedit.component'
import { danhmucchungeditComponent } from './components/danhmuc/danhmucchungedit.component'
import { loaicauhoieditComponent } from './components/danhmuc/loaicauhoiedit.component'
import { loaithieditComponent } from './components/danhmuc/loaithiedit.component'
import { choncanboeditComponent } from './components/tonghop/choncanboedit.component'
import { danhsachthieditComponent } from './components/danhmuc/danhsachthiedit.component'
import { ngayhethaneditComponent } from './components/danhmuc/ngayhethanedit.component'
import { phonghoceditComponent } from './components/danhmuc/phonghocedit.component'
import { kenheditComponent } from './components/danhmuc/kenhedit.component'
import { trinhdodaotaoeditComponent } from './components/danhmuc/trinhdodaotaoedit.component'
import { hedaotaoeditComponent } from './components/danhmuc/hedaotaoedit.component'
import { donvitinheditComponent } from './components/danhmuc/donvitinhedit.component'
import { nhacungcapeditComponent } from './components/danhmuc/nhacungcapedit.component'
import { sanphameditComponent } from './components/danhmuc/sanphamedit.component'
import { khohangeditComponent } from './components/danhmuc/khohangedit.component'
import { nhapkhoeditComponent } from './components/danhmuc/nhapkhoedit.component'
import { nhapkhonhieueditComponent } from './components/danhmuc/nhapkhonhieuedit.component'
import { xuatkhoeditComponent } from './components/danhmuc/xuatkhoedit.component'
import { xuatkhonhieueditComponent } from './components/danhmuc/xuatkhonhieuedit.component'
import { ChuongTrinhKhuyenMaiComponent } from './components/danhmuc/chuongtrinhkhuyenmai.component'



import { choncauhoieditComponent } from './components/tonghop/choncauhoiedit.component'
import { chontaikhoaneditComponent } from './components/tonghop/chontaikhoanedit.component'

import { baivieteditComponent } from './components/baiviet/baivietedit.component';
import { baivietviewComponent } from './components/baiviet/baivietview.component';
import { baivietcheckComponent } from './components/baiviet/baivietcheck.component';
import { baivietinfoComponent } from './components/baiviet/baivietinfo.component';
import { dangkyeditComponent } from './components/danhmuc/dangkyedit.component'
import { tuychinhmaubceditComponent } from './components/tonghop/tuychinhmaubcedit.component'
import { chonhocvieneditComponent } from './components/tonghop/chonhocvienedit.component'
import { SoLienLacEditComponent } from './components/daotao/solienlacedit.component'
import { chondangkygoihoceditComponent } from './components/tonghop/chondangkygoihocedit.component'
import { PhanBoChiPhiEditComponent } from './components/dieuhanh/phanbo-chiphiedit.component';
import { TaothuHocPhiComponent } from './components/daotao/taothuhocphi.component';
import { CustomDatepickerComponent } from './components/common/custom-datepicker.component';

import { FilterPipe } from './pipes/filter.pipe';
import { SafePipe } from './pipes/salepipe';

// https://angular.io/styleguide#!#04-10
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    DatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    ProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    ToastrModule.forRoot(),
    ToasterModule,
    NgSelectModule,
    DialogModule,
    DateInputsModule,
    MultiSelectAllModule,
    DropDownListModule,
    ListBoxAllModule,
    MaskedTextBoxModule,
    DropDownButtonModule,
    TreeGridAllModule,
    RichTextEditorAllModule,
    ToolbarModule,
    TreeViewModule,
    CheckBoxModule,
    RadioButtonModule,
    ButtonModule,
    SwitchModule,
    TextBoxModule,
    BsModalModule,
    NumericTextBoxModule,
    Ng2SmartTableModule,
   DatePickerModule,
   TimePickerModule,
    RecurrenceEditorAllModule,
    ScheduleAllModule,
    FileManagerAllModule,
    ContextMenuModule,
    GridAllModule,
    NgxCurrencyModule,
    FileUploadModule,
    UploaderModule,
    SplitterModule,
    SidebarModule,
    PdfViewerModule,
    AngularSplitModule
    
  ],
  providers: [ColorsService,
    Repository,
    ToolDataService,
    AuthorizationService,
    ToasterService,
    TranslationService,
  ],
  declarations: [
    SafePipe,
    FilterPipe,
    CheckallDirective,
    TranslateDirective,
    NowDirective,
    ScrollableDirective,
    ScrollToBottomDirective,
    VjsPlayerComponent,
    TranslatePipe,
    FillBlanksReplacePipe,
    quatrinhdaotaoComponent,
    donvisudungeditComponent,
    thongtinkhoahoceditComponent,
    lophoceditComponent,
    tuvankhoahoceditComponent,
    dangkykhoahoceditComponent,

    dangkykheditComponent,
    tuvaneditComponent,
    danhsachlichhoceditComponent,
    lichhoceditComponent,
    danhsachgiaotrinheditComponent,
    giaotrinheditComponent,
    nhatkychamsoceditComponent,
    nhatkytheodoieditComponent,
    hocvieneditComponent,
    doimatkhaueditComponent,
    doitaikhoaneditComponent,
    baoluunghihoceditComponent,
    khoataikhoaneditComponent,
    chotsobuoihoceditComponent,
    nhacvieceditComponent,
    thongbaohocphieditComponent,
    cauhinhhienthieditComponent,
    chuyenlopeditComponent,
    chuyenlopchonhocvieneditComponent,
    dangkygoihoceditComponent,
    dangkyhoceditComponent,
    dangkymuadungcueditComponent,
    danhsachlophoceditComponent,
    danhsachphatdungcueditComponent,
    datlichthuhocphieditComponent,
    donghoceditComponent,
    phanlopeditComponent,
    phanhocvieneditComponent,
    phanhocvientiemnangeditComponent,
    lichsuchuyenlopeditComponent,
    phatdungcueditComponent,
    phatdungcunhieueditComponent,
    diemdanheditComponent,
    thongkediemdanheditComponent,
    thietlapngaytaoeditComponent,
    kiemtradauvaoeditComponent,
    khuvuceditComponent,
    hocvientiemnangeditComponent,
    hocthueditComponent,
    chitietphaithuphaitraeditComponent,
    loaiphieueditComponent,
    thuchieditComponent,
    dkycanboeditComponent,
    filemanagerComponent,
    phanheeditComponent,
    importeditComponent,
    danhmucchungeditComponent,
    loaicauhoieditComponent,
    loaithieditComponent,
    choncanboeditComponent,
    danhsachthieditComponent,
    ngayhethaneditComponent,
    phonghoceditComponent,
    kenheditComponent,
    trinhdodaotaoeditComponent,
    hedaotaoeditComponent,
    donvitinheditComponent,
    nhacungcapeditComponent,
    sanphameditComponent,
    khohangeditComponent,
    nhapkhoeditComponent,
    xuatkhoeditComponent,
    nhapkhonhieueditComponent,
    xuatkhonhieueditComponent,
    ChuongTrinhKhuyenMaiComponent, 
    choncauhoieditComponent,
    chontaikhoaneditComponent,
    baivieteditComponent,
    baivietviewComponent,
    baivietcheckComponent,
    baivietinfoComponent,
    dangkyeditComponent,
    tuychinhmaubceditComponent,
    chonhocvieneditComponent,
    chondangkygoihoceditComponent,
    SoLienLacEditComponent,
    chonhocvientiemnangeditComponent,
    chonlophoceditComponent,
    PhanBoChiPhiEditComponent,
    TaothuHocPhiComponent,
    CustomDatepickerComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    AccordionModule,
    AlertModule,
    ButtonsModule,
    CarouselModule,
    CollapseModule,
    DatepickerModule,
    BsDatepickerModule,
    BsDropdownModule,
    ModalModule,
    PaginationModule,
    ProgressbarModule,
    RatingModule,
    TabsModule,
    TimepickerModule,
    TooltipModule,
    PopoverModule,
    TypeaheadModule,
    ToastrModule,
   
    CheckallDirective,
    ContextMenuModule,
    NowDirective,
    ScrollableDirective,
    VjsPlayerComponent,
    TranslatePipe,
    FillBlanksReplacePipe,
    TranslateDirective,

    ToasterModule,
    DialogModule,
    MultiSelectAllModule,
    DropDownListModule,
    ListBoxAllModule,
    MaskedTextBoxModule,
    DropDownButtonModule,
    TreeGridAllModule,
    RichTextEditorAllModule,
    ToolbarModule,
    TreeViewModule,
    CheckBoxModule,
    RadioButtonModule,
    SwitchModule,
    TextBoxModule,
    ButtonModule,
    NumericTextBoxModule,
    NgSelectModule,
    DatePickerModule,
   TimePickerModule,
    RecurrenceEditorAllModule,
    ScheduleAllModule,
    FileManagerAllModule, 
   
    GridAllModule,
    NgxCurrencyModule,
    //NgxTreeSelectModule,
    FileUploadModule,
    UploaderModule,
    SplitterModule,
    SidebarModule,
    PdfViewerModule,
    AngularSplitModule,

    quatrinhdaotaoComponent,
    donvisudungeditComponent,
    thongtinkhoahoceditComponent,
    lophoceditComponent,
    tuvankhoahoceditComponent,
    dangkykhoahoceditComponent,
    dangkykheditComponent,
    tuvaneditComponent,
    dkycanboeditComponent,
    filemanagerComponent,
    phanheeditComponent,
    importeditComponent,
    danhmucchungeditComponent,
    loaicauhoieditComponent,
    loaithieditComponent,
    choncanboeditComponent,
    danhsachthieditComponent,
    ngayhethaneditComponent,
    phonghoceditComponent,
    kenheditComponent,
    trinhdodaotaoeditComponent,
    hedaotaoeditComponent,
    donvitinheditComponent,
    nhacungcapeditComponent,
    sanphameditComponent,
    khohangeditComponent,
    nhapkhoeditComponent,
    xuatkhoeditComponent,
    nhapkhonhieueditComponent,
    xuatkhonhieueditComponent,
    ChuongTrinhKhuyenMaiComponent,
    choncauhoieditComponent,
    chontaikhoaneditComponent,
    baivieteditComponent,
    baivietviewComponent,
    baivietcheckComponent,
    baivietinfoComponent,
    dangkyeditComponent,
    tuychinhmaubceditComponent,
    chonhocvieneditComponent,
    chondangkygoihoceditComponent,
    chonhocvientiemnangeditComponent,
    chonlophoceditComponent,
    hocvientiemnangeditComponent,
    khuvuceditComponent,
    SoLienLacEditComponent,
    thuchieditComponent,
    loaiphieueditComponent,
    kiemtradauvaoeditComponent,
    hocthueditComponent,
    chitietphaithuphaitraeditComponent,
    danhsachgiaotrinheditComponent,
    giaotrinheditComponent,
    nhatkychamsoceditComponent,
    nhatkytheodoieditComponent,
    hocvieneditComponent,
    doimatkhaueditComponent,
    doitaikhoaneditComponent,
    baoluunghihoceditComponent,
    khoataikhoaneditComponent,
    chotsobuoihoceditComponent,
    nhacvieceditComponent,
    thongbaohocphieditComponent,
    cauhinhhienthieditComponent,
    chuyenlopeditComponent,
    chuyenlopchonhocvieneditComponent,
    dangkygoihoceditComponent,
    dangkyhoceditComponent,
    dangkymuadungcueditComponent,
    danhsachlophoceditComponent,
    danhsachphatdungcueditComponent,
    datlichthuhocphieditComponent,
    donghoceditComponent, 
    phanlopeditComponent,
    phanhocvieneditComponent,
    phanhocvientiemnangeditComponent,
    lichsuchuyenlopeditComponent,
    phatdungcueditComponent,
    phatdungcunhieueditComponent,
    diemdanheditComponent,
    thongkediemdanheditComponent,
    FilterPipe,
    SafePipe,
    ScrollToBottomDirective,
    PhanBoChiPhiEditComponent,
    TaothuHocPhiComponent,
    CustomDatepickerComponent
  ],
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
